module.exports = __webpack_public_path__ + "static/media/11.2f906dce.mp3";